import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import { SYNC_ZWAVE_DEVICES } from '@app/constants/scenes/zWaveDevices/zWaveDevices'
import { updateZWaveDevices } from '@app/actions/scenes/zWaveDevices/zWaveDevices'
import fetchZWaveDevices from '@app/api/scenes/ZWaveDevices/fetchZWaveDevices'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestSent, apiRequestDone, apiRequestFailed } from '@app/actions/apiRequest'

const fetchZWaveDevicesLogic = createLogic({
  type: SYNC_ZWAVE_DEVICES,
  cancelType: API_REQUEST_CANCEL,

  process(_, dispatch, done) {
    const { secrets: { accessToken: { token } } } = store.getState()
    dispatch(apiRequestSent(SYNC_ZWAVE_DEVICES))
    fetchZWaveDevices(token)
      .then((response) => {
        const { data: { zwave_devices } } = response
        dispatch(updateZWaveDevices(zwave_devices))
        dispatch(apiRequestDone(SYNC_ZWAVE_DEVICES))
      })
      .catch((error) => {
        if (error) {
          const currentError = handleErrors(error)
          dispatch(apiRequestFailed(currentError))
        } else {
          throw new Error('fetchZWaveDevices failed without error')
        }
      })
      .then(() => done())
  },
})

export default fetchZWaveDevicesLogic
